import { Loader } from '@googlemaps/js-api-loader';

const GOOGLE_MAP_API_KEY = 'AIzaSyDMUd2TyUzjQDhNksbiKQ0zT95gEjbGBPw';

export default new Loader({
  apiKey: GOOGLE_MAP_API_KEY,
  version: "weekly",
  libraries: ["places"]
});
